import { Product } from "../../types/product";
import { ProductItem } from "./ProductItem.comp";
import productCore from "../../core/product.core";

interface ProductGridSectionProps {
  products: Product[];
  wishlistedItems: Set<string>;
  updateWishlistItem: (productName: string, wishlistStatus: boolean) => void;
  giftCardsTypesIDs?: string[];
  withWrapper?: boolean;
}

export function ProductGridSection({
  products,
  wishlistedItems,
  updateWishlistItem,
  giftCardsTypesIDs,
  withWrapper = true,
}: ProductGridSectionProps) {
  const gridContent = (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 px-2">
      {products.map((product: Product) => (
        <div className="flex justify-center" key={product.id}>
          <ProductItem
            key={product.id}
            product={product}
            wishList={wishlistedItems.has(product.id)}
            updateItem={updateWishlistItem}
            showDiscount={true}
            isCoupon={
              product.giftCardDefId && giftCardsTypesIDs
                ? !productCore.isGiftCardMatched(product.giftCardDefId, giftCardsTypesIDs)
                : false
            }
          />
        </div>
      ))}
    </div>
  );

  if (withWrapper) {
    return <div className="flex-1 p-4">{gridContent}</div>;
  }

  return gridContent;
}
